import React from 'react';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const notify = (message: string) => toast(
    message, {
        position: 'top-left'
    }
);

export const Toast = () => {
    return (
        <div>
            <ToastContainer
                hideProgressBar={true}
                closeButton={false}
                toastClassName={() => {
                    return (
                        `py-2 pl-4 pr-4 max-w-screen-xl bg-gradient-to-r from-toastGradientStart via-toastGradientMiddle to-toastGradientEnd
                         rounded-md flex flex-row items-center my-1 shadow-md`
                    );
                }}
                bodyClassName={() => 'text-[#FFFFFF] text-sm font-normal'}
            />
        </div>
    );
}
